import { render, staticRenderFns } from "./TileBody.vue?vue&type=template&id=59a561d0&"
var script = {}
import style0 from "./TileBody.vue?vue&type=style&index=0&id=59a561d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports